import React from 'react';

const UnderConstruction: React.FC = () => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-100 p-4">
      <div className="max-w-2xl text-center">
        <img 
          src="https://media.giphy.com/media/3oEjI6SIIHBdRxXI40/giphy.gif"
          alt="En construcción"
          className="w-64 h-64 mx-auto mb-8"
        />
        <h1 className="text-4xl font-bold text-gray-800 mb-4">
          ¡Este sitio aún se encuentra en desarrollo!
        </h1>
        <p className="text-xl text-gray-600 mb-8">
          No te pierdas las actualizaciones y avanza junto con Buksy
        </p>
        {/* Puedes agregar aquí un botón para volver a la página principal si lo deseas */}
      </div>
    </div>
  );
};

export default UnderConstruction;